import React, { useState } from "react";
import { Avatar, Button, Drawer, IconButton, Link } from "@material-ui/core";
import { Close } from "@material-ui/icons";
import Skeleton from "@material-ui/lab/Skeleton";
import { i18n } from "../../translate/i18n";
import { messengerText as text } from "../../translate/messenger";
import ContactModal from "../ContactModal";
import MarkdownWrapper from "../MarkdownWrapper";
import TicketTags from "../TicketTags";
import WhatsappLabels from "../WhatsappLabels";

export default function ContactDrawer({ open, handleDrawerClose, contact, ticket, loading }) {
  const [modalOpen, setModalOpen] = useState(false);
  let portalContext = null;
  try {
    portalContext = ticket.channel === "portal" && ticket.portalContext ? JSON.parse(ticket.portalContext) : null;
  } catch (_) {
    portalContext = null;
  }
  return <Drawer variant="temporary" anchor="right" open={open} onClose={handleDrawerClose} classes={{ paper: "tw-w-full sm:tw-w-[360px]" }}>
    <div className="tw-flex tw-min-h-[72px] tw-shrink-0 tw-items-center tw-gap-2 tw-border-0 tw-border-b tw-border-solid tw-border-slate-100 tw-bg-white tw-px-3 dark:tw-border-slate-700 dark:tw-bg-[#172b22]">
      <IconButton aria-label={text("close")} onClick={handleDrawerClose}><Close /></IconButton>
      <strong>{i18n.t("contactDrawer.header")}</strong>
    </div>
    <div className="tw-min-h-0 tw-flex-1 tw-overflow-y-auto tw-bg-slate-50 tw-p-5 dark:tw-bg-[#0f1c16]">
      {loading ? <Skeleton variant="rect" height={250} /> : <>
        <div className="tw-flex tw-flex-col tw-items-center tw-gap-3 tw-py-5">
          <Avatar alt={contact.name} src={contact.profilePicUrl} className="tw-h-28 tw-w-28 tw-bg-slate-300 tw-text-4xl">{contact.name?.charAt(0)}</Avatar>
          <h2 className="tw-m-0 tw-text-xl tw-font-medium">{contact.name}</h2>
          {contact.number && <Link href={`tel:${contact.number}`}>{contact.number}</Link>}
          <Button color="primary" className="tw-rounded-full tw-normal-case" onClick={() => setModalOpen(true)}>{i18n.t("contactDrawer.buttons.edit")}</Button>
        </div>
        <div className="tw-my-3 tw-rounded-2xl tw-bg-white tw-p-4 dark:tw-bg-[#172b22]">
          <span className="tw-text-xs tw-text-slate-500 dark:tw-text-slate-300">#{ticket.id} · {ticket.queue?.name}</span>
          <div className="tw-mt-3 tw-flex tw-flex-col tw-gap-3 [&>div]:tw-flex-wrap"><WhatsappLabels labels={ticket.labels} limit={20} /><TicketTags ticket={ticket} /></div>
          {portalContext && <p className="tw-break-words tw-text-sm">{[portalContext.subject, portalContext.courseName].filter(Boolean).join(" · ")}</p>}
        </div>
        <div className="tw-my-3 tw-rounded-2xl tw-bg-white tw-p-4 dark:tw-bg-[#172b22]">
          <h3 className="tw-m-0 tw-text-sm tw-font-medium">{i18n.t("contactDrawer.extraInfo")}</h3>
          {contact.extraInfo?.map(info => <div key={info.id} className="tw-mt-4 tw-break-words">
            <div className="tw-text-xs tw-text-slate-500 dark:tw-text-slate-300">{info.name}</div>
            <MarkdownWrapper>{info.value}</MarkdownWrapper>
          </div>)}
        </div>
        <ContactModal open={modalOpen} onClose={() => setModalOpen(false)} contactId={contact.id} />
      </>}
    </div>
  </Drawer>;
}
